import { useNavigate } from 'react-router-dom';
import { useLocale } from '../../i18n/LocaleContext';
import { defaultLocale, type Locale, locales } from '../../messages';

const STORAGE_KEY = 'ra-locale';

// Native language names (endonyms) — a French speaker scans for "Français".
const NAMES: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  it: 'Italiano',
};

const pathFor = (locale: Locale): string => (locale === defaultLocale ? '/' : `/${locale}/`);

export const LocaleSwitcher = () => {
  const current = useLocale();
  const navigate = useNavigate();

  const onChange = (locale: Locale) => {
    if (locale === current) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, locale);
    } catch {
      // ignore storage failures (private mode, etc.)
    }
    navigate(pathFor(locale));
  };

  return (
    <select
      className="locale-switch"
      aria-label="Language"
      value={current}
      onChange={(e) => onChange(e.target.value as Locale)}
    >
      {locales.map((locale) => (
        <option key={locale} value={locale}>
          {NAMES[locale]}
        </option>
      ))}
    </select>
  );
};
